import tippy from "tippy.js";
import jquery from "jquery";
import { initIntersectionObserver } from "@plugins";

const $ = jquery;

$(document).ajaxSuccess(() => initLabelsTooltips());

window.addEventListener("load", initLabelsTooltips());

function initLabelsTooltips() {
    const labelsWraps = document.querySelectorAll(".card-labels");

    if (labelsWraps && labelsWraps.length) {
        for (const wrap of labelsWraps) {
            setTimeout(() => initIntersectionObserver(wrap, initLabelsInsideWrap), 0);
        }
    }
}

function initLabelsInsideWrap(wrap) {
    const labels = wrap.querySelectorAll(".js-small-label");

    if (labels && labels.length) {
        for (const label of labels) {
            if (label.hasAttribute("data-announcing")) {
                setTimeout(() => initLabelTooltip(label));
            }
        }
    }
}

function initLabelTooltip(target) {
    tippy(target, {
        arrow: true,
        theme: "light",
        placement: window.mobileMedia ? "top" : "right",
        maxWidth: 300,
        ignoreAttributes: true,
        trigger: "mouseenter click",
        hideOnClick: true,
        allowHTML: true,
        onCreate(instance) {
            instance.setContent(instance.reference.dataset.announcing);
            instance.reference.removeAttribute("data-announcing");
        },
    });
}
